import React from 'react';
import './index.css';

// Components
import MatchContainer from '../../containers/MatchContainer';
import PropertyMatchList from '../User/Shared/Matches/PropertyMatchList';

// Assets
import TenantIcon from '../../images/icons/tenant_icon.png';
import { bucketUrl } from '../../actions/utils'
import TenantMatchList from '../User/Shared/Matches/TenantMatchList';
import LinkHelper from '../Helpers/Link';
import { Button } from '@material-ui/core';

class Dashboard extends React.Component {

	componentDidMount() {
		// console.log(this.props)
		this.props.loadInterests(this.props.currentAnnouncement);
		this.props.setAsListener(this.props.loadInterests);
	}

	componentWillUnmount() {
		this.props.setAsListener(undefined);
	}

	translateInterestedTenants(matches) {
		return matches.map((match) => ({
			...match,
			user: match.isInterested && match.isInterested[0]
		}))
	}

	translateName(user) {
		if (user.privateTenant) {
			return `${user.privateTenant.firstName} ${user.privateTenant.lastName
				}`;
		}
		if (user.organizationTenant) {
			return `${user.organizationTenant.name} - ${user.organizationTenant.contactFirstName
				} ${user.organizationTenant.contactLastName}`;
		}
	};

	renderUserInfo(user) {
		const {
			// id,
			file,
		} = user;
		return (
			<div className='user-info-container'>
				<div className='user-profile'>
					<h4>Your account</h4>
					<div className='info-content'>
						<div className='profile-container'>
							<img
								src={
									file ?
										`${bucketUrl}/${file.key}` :
										TenantIcon
								}
								alt='profile'
							/>
							<p className='user-name'>{this.translateName(user)}</p>
						</div>
					</div>
				</div>
				<div className='payment-container'>
					<h5>Payment</h5>
					<p>Coming soon</p>
				</div>
				<div className='application-tracking-container'>
					<h5>Application status</h5>
					<p>Coming soon</p>
				</div>
			</div>
		)
	}

	renderMatches(matches) {
		console.log(this.props, matches)
		return (
			this.props.user.isLandlord !== true ?
				<div className='matches-container'>

					<h4>The properties you are interested in appear here</h4>
					{
						matches.length === 0 ?
							<LinkHelper to="/user/matches">
								<Button
									variant="outlined"
									color="secondary"
									size="large"
								>
									Go here to find matches
								</Button>
							</LinkHelper> :
							<MatchContainer
								component={PropertyMatchList}
								matches={matches}
								fromDashboard
							/>
					}
				</div> :
				<div className='matches-container'>

					<h4>Tenants that are interested in your property</h4>
					{
						matches.length === 0 ?
							<p>No tenants yet</p> :
							<MatchContainer
								component={TenantMatchList}
								matches={this.translateInterestedTenants(matches)}
							/>
					}
				</div>

		)
	}

	render() {
		const { user, interests, favoriteMatches } = this.props;
		console.log("INTERESTS >>", interests, favoriteMatches);
		return (
			<div className='dashboard-container'>
				{
					user ?
						this.renderUserInfo(user)
						: null
				}
				{favoriteMatches && favoriteMatches.length > 0 ?
					<div>
						{this.renderMatches(favoriteMatches)}
					</div>
					: interests !== undefined &&
					<div>
						{this.renderMatches(interests)}
					</div>
				}
			</div>
		)
	}
}

export default Dashboard;